/**
 * Explanation Panel
 * Displays human-readable explanations of production intelligence
 */

import React, { useState } from 'react';
import './ExplanationPanel.css';

const ExplanationPanel = ({ explanations }) => {
  const [expandedMetric, setExpandedMetric] = useState(null);

  if (!explanations) {
    return (
      <div className="explanation-panel">
        <p>No analysis available.</p>
      </div>
    );
  }

  const toggleMetric = (index) => {
    setExpandedMetric(expandedMetric === index ? null : index);
  };

  return (
    <div className="explanation-panel">
      {/* Overall Summary */}
      <div className="explanation-summary">
        <div className="summary-icon">🧠</div>
        <div className="summary-content">
          <h4>Asset Performance Summary</h4>
          <p>{explanations.summary}</p>
        </div>
      </div>

      {/* Detailed Explanations */}
      {explanations.details && explanations.details.length > 0 && (
        <div className="explanation-details">
          <h4>Impact Analysis</h4>
          {explanations.details.map((detail, index) => (
            <div key={index} className="detail-card">
              <div 
                className="detail-header"
                onClick={() => toggleMetric(index)}
              >
                <span className="detail-metric">{detail.metric}</span>
                <span className="detail-message">{detail.message}</span>
                <span className="expand-icon">
                  {expandedMetric === index ? '▼' : '▶'}
                </span>
              </div>
              
              {expandedMetric === index && detail.rootCauses && (
                <div className="detail-body">
                  <h5>Root Causes:</h5>
                  <ul className="root-causes-list">
                    {detail.rootCauses.map((cause, causeIndex) => (
                      <li key={causeIndex}>{cause}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Recommendations */}
      {explanations.recommendations && explanations.recommendations.length > 0 && (
        <div className="explanation-recommendations">
          <h4>Recommended Actions</h4>
          <div className="recommendations-list">
            {explanations.recommendations.slice(0, 5).map((rec, index) => (
              <div key={index} className="recommendation-card">
                <div className="rec-priority">
                  <span className="priority-badge">Priority {index + 1}</span>
                  <span className="upside-badge">
                    Potential Upside: {(rec.potentialUpside ?? 0).toLocaleString(undefined, {
  maximumFractionDigits: 0,
})}
 {rec.unit || 'Units'}
                  </span>
                </div>
                <div className="rec-action">
                  {rec.action}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Empty State */}
      {explanations.details.length === 0 && explanations.recommendations.length === 0 && (
        <div className="explanation-empty">
          <p>✓ All production targets are achievable with current conditions.</p>
          <p>No blocking issues identified.</p>
        </div>
      )}
    </div>
  );
};

export default ExplanationPanel;